/// <reference path="../include.ts" />

namespace project_common {

	import Logger = alm.debug.Logger;

	export class QrCodeUtil {

		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public static initialize(spotUrn:string):void {
			trace('[QrCodeUtil] initialize : spotUrn =', spotUrn);
			QrCodeUtil.spotUrn = spotUrn;
			QrCodeUtil.rootUri = '';
		}

		public static getImageUrl(uri:string):string {
			if (!QrCodeUtil.spotUrn) {
				Logger.error('[QrCodeUtil] QrCodeUtil.initialize is not called : uri =', uri);
				return '';
			}
			trace('[QrCodeUtil] generate : uri =', uri);
			return QrCodeUtil.rootUri + '/guide/' + QrCodeUtil.spotUrn + '/data/qrcode?u=' + encodeURIComponent(uri) + (Application.getPresetContext().deployMode === DeployMode.release ? '' : '&log=1');
		}

		public static getGuideQrCodeImageUrl():string {
			return QrCodeUtil.getImageUrl(['guide', QrCodeUtil.spotUrn].join('/') + '/');
		}

		public static getZoneQrCodeImageUrl(regionUrn:string, areaUrn:string, zoneUrn:string):string {
			return QrCodeUtil.getImageUrl(['guide', QrCodeUtil.spotUrn, '#', regionUrn, areaUrn, zoneUrn].join('/'));
		}

		public static getSpeciesQrCodeImageUrl(regionUrn:string, areaUrn:string, zoneUrn:string, speciesUrn:string):string {
			return QrCodeUtil.getImageUrl(['guide', QrCodeUtil.spotUrn, '#', regionUrn, areaUrn, zoneUrn, speciesUrn].join('/'));
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private static rootUri:string = null;
		private static spotUrn:string = null;





		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
		}
	}
}
